var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneEnd = function SvgPhoneEnd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C10.4062 6 8.875 6.23438 7.40625 6.70312V9.79688C7.40625 10.2344 7.21875 10.5469 6.84375 10.7344C5.875 11.2031 4.98438 11.8125 4.17188 12.5625C3.98438 12.75 3.75 12.8438 3.46875 12.8438C3.1875 12.8438 2.95312 12.75 2.76562 12.5625L0.28125 10.0781C0.09375 9.89062 0 9.65625 0 9.375C0 9.09375 0.09375 8.85938 0.28125 8.67188C3.5625 5.54688 7.46875 3.98438 12 3.98438C16.5312 3.98438 20.4375 5.54688 23.7188 8.67188C23.9062 8.85938 24 9.09375 24 9.375C24 9.65625 23.9062 9.89062 23.7188 10.0781L21.2344 12.5625C21.0469 12.75 20.8125 12.8438 20.5312 12.8438C20.25 12.8438 20.0156 12.75 19.8281 12.5625C19.0469 11.8438 18.1562 11.2344 17.1562 10.7344C16.7812 10.5469 16.5938 10.25 16.5938 9.84375V6.75C15.125 6.25 13.5938 6 12 6Z",
    fill: "#F8F8F8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneEnd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PhoneEnd.b4321500.svg";
export { ForwardRef as ReactComponent };